import { SentryApi } from "src/lib/sentry";

type ErrorContext = Record<string, unknown>;

function isErrorContext(value: unknown): value is ErrorContext {
	return typeof value === "object" && value !== null && "operation" in value;
}

/**
 * Report a handled client error without leaking it to the browser console.
 * Keep context identifiers-only: never include credentials, payment payloads,
 * auth tokens, or full customer/entity objects.
 */
export function reportError(...values: unknown[]): void {
	const explicitContext = values.length === 2 && isErrorContext(values[1]) ? values[1] : undefined;
	const error = values.find((value) => value instanceof Error);
	const message =
		typeof values[0] === "string" ? values[0] : "Handled client operation failed";
	const normalized = error instanceof Error ? error : new Error(message);
	const context = explicitContext ?? (typeof values[0] === "string" ? { operation: values[0] } : {});

	SentryApi.captureException(normalized, context);
}
